export default {
    app: {
        home: {
            subscribed: "Iscritto",
            following: "Segui",
            discover: "Scopri",
        },
    },
    user: {
        setting: {
            main: {
                title: "Impostazioni",
                delete_account: "Elimina Account",
                logout: "Esci",
            },
            language: {
                title: "Lingua",
                button: "Fatto",
            },
            password: {
                title: "Password",
                old_password: "Vecchia password",
                new_password: "Nuova password",
                confirm_password: "Conferma password",
                update: "Aggiorna",
            },
            email: {
                title: "Email",
                email: "Email",
                example: "esempio@example.com",
                update: "Aggiorna",
            },
            notification: {
                title: "Notifiche",
                app: "App",
                follow: "Segui",
                new_subscriber: "Nuovo Iscritto",
                messages: "Messaggi",
                email: "Email",
                fund_sent: "Fondi Inviati",
                tips_received: "Fondi Ricevuti",
                save: "Salva",
            },
            blacklist: {
                title: "Utenti Bloccati",
            },
            block_regions: {
                title: "Blocca Paesi",
            },
            sessions: {
                title: "Sessioni",
                something_went_wrong: "Qualcosa è andato storto?",
                change_your_password: "Cambia la tua password",
                device: "Dispositivo",
                browser: "Browser",
                date: "Data",
            },
            contact: {
                title: "Contattaci",
                placeholder: "Cosa Succede?",
                send: "Invia",
                sent: "Inviato",
                type_label: "Cosa ti porta qui?",
            },
            creator: {
                title: "Noodzler",
                verify: {
                    title: "Verifica Account",
                },
                agreement: {
                    title: "Contratto di Accordo",
                    sub_title: "CONTRATTO STANDARD TRA NOODZLY E NOODZLER",
                    field: {
                        name: "Nome",
                    },
                    btn: {
                        accept: "accetta",
                    },
                },
                verify_ondato: {
                    title: "Verifica il tuo account",
                    verify_account: "Account verificati",
                    action_link: "inizia la verifica",
                    add_another_model: "Aggiungi un altro account",
                    model_has_verified: "{name} è stato verificato il",
                    model_not_verified: "Il Noodzler {name} non è verificato",
                    status_created: " ",
                    status_processed: "elaborato",
                    status_resolved: "risolto",
                    status_rejected: "respinto",
                    reverify_button: "Ri-verificare",
                    model_verification_expired: 'Il documento di {name} è scaduto. Verifica nuovamente per continuare',
                    remove_verification: 'Rimuovere',
                },
                withdraw_options: {
                    title: "Opzioni Prelievo",
                    withdraw: {
                        title: "Prelievo",
                        bank_transfer: {
                            title: "Bonifico Bancario",
                            swift_code: "Codice SWIFT",
                            placeholder_swift_code: "Inserisci il Codice SWIFT",
                            iban_number: "Codice IBAN",
                            placeholder_iban_number: "Inserisci il Codice IBAN",
                            bank_name: "Nome della Banca",
                            placeholder_bank_name:
                                "Inserisci il Nome della Banca",
                            bank_country: "Paese della Banca",
                            placeholder_bank_country: "Paese",
                            convert_currency: "Convertiremo USD in EUR il giorno del pagamento tramite {ecb_rate_link}",
                            note_1: "Tempo per ricevere il pagamento: i pagamenti Sepa & Swift vengono ora elaborati GIORNALMENTE (da lunedì a venerdì). I fondi richiesti entro le 23:59 EST verranno elaborati il giorno lavorativo successivo. Si prega di attendere ulteriori 5-7 giorni lavorativi per l'accredito dei fondi sul tuo conto.",
                            note_2: "NOTA: La tua banca (o banca intermedia) potrebbe addebitarti commissioni oltre alle tariffe. Le commissioni addebitate dalla tua banca (o banca intermedia) non sono sotto il nostro controllo. Consulta la tua banca prima di richiedere un pagamento se non sei sicuro.",
                            beneficiary_name: 'Nome del beneficiario',
                            placeholder_beneficiary_name: 'Inserisci il nome del beneficiario',
                            beneficiary_street: 'Via del beneficiario',
                            placeholder_beneficiary_street: 'Inserisci la via del beneficiario',
                            beneficiary_city: 'Città beneficiaria',
                            placeholder_beneficiary_city: 'Inserisci la città beneficiaria',
                            beneficiary_country: 'Paese beneficiario',
                            placeholder_beneficiary_country: 'Inserisci il Paese beneficiario',
                            beneficiary_state: 'Stato beneficiario',
                            placeholder_beneficiary_state: 'Inserisci lo Stato beneficiario',
                            beneficiary_zip: 'CAP del beneficiario',
                            placeholder_beneficiary_zip: 'Inserisci CAP beneficiario',
                        },
                        bitsafe: {
                            title: "Yoursafe",
                            full_name: "Nome Completo del Beneficiario",
                            iban: "Yoursafe IBAN",
                            country: "Paese",
                        },
                        wire_transfer: {
                            title: "Bonifico bancario internazionale",
                            swift_code: "Codice SWIFT",
                            placeholder_swift_code: "Inserisci il Codice SWIFT",
                            iban_number: "Codice IBAN",
                            placeholder_iban_number: "Inserisci il Codice IBAN",
                            bank_name: "Nome della Banca",
                            placeholder_bank_name: "Inserisci il Nome della Banca",
                            bank_country: "Paese della Banca",
                            placeholder_bank_country: "Paese",
                            convert_currency: "Convertiremo USD in EUR il giorno del pagamento tramite {ecb_rate_link}",
                            note_1: "Time to receive payment: Sepa & Swift payments are now processed DAILY (Monday - Friday). Funds requested prior to 23:59 EST will be processed the following business day. Please allow an additional 5 - 7 business days for the funds to settle in your account.",
                            note_2: "NOTE: Your bank (or intermediary bank) may charge you fees in addition to the fees. Fees charged by your bank (or intermediary bank) are not under our control. Please consult with your bank prior to requesting a payment if you are unsure.",
                            beneficiary_name: 'Nome del beneficiario',
                            placeholder_beneficiary_name: 'Inserisci il nome del beneficiario',
                            beneficiary_street: 'Via del beneficiario',
                            placeholder_beneficiary_street: 'Inserisci la via del beneficiario',
                            beneficiary_city: 'Città beneficiaria',
                            placeholder_beneficiary_city: 'Inserisci la città beneficiaria',
                            beneficiary_country: 'Paese beneficiario',
                            placeholder_beneficiary_country: 'Inserisci il Paese beneficiario',
                            beneficiary_state: 'Stato beneficiario',
                            placeholder_beneficiary_state: 'Inserisci lo Stato beneficiario',
                            beneficiary_zip: 'CAP del beneficiario',
                            placeholder_beneficiary_zip: 'Inserisci CAP beneficiario',
                        },
                        crypto_wallet: {
                            title: "Criptovaluta",
                            wallet_address: "Indirizzo del portafoglio crittografico",
                            placeholder_wallet_address: "Inserisci l'indirizzo del portafoglio crittografico",
                            crypto_currency: "Criptovaluta",
                            placeholder_crypto_currency: "Seleziona Cripto",
                            country: "Paese",
                            placeholder_country: "Seleziona Paese",
                        },
                    },
                },
                streams: {
                    title: "Streaming Privato",
                    tabs: {
                        now: "Ora",
                        later: "Programma",
                    },
                    fields: {
                        price: {
                            title: "Prezzo",
                        },
                        ticketsSold: {
                            title: "Biglietti venduti",
                        },
                        viewersLimit: {
                            title: "Limite Spettatori",
                        },
                        dateTime: {
                            title: "Inizia alle",
                        },
                        isFreeForSubscribers: {
                            title: "Gratuito per gli abbonati",
                        },
                        rating: {
                            title: "Punteggio dei tuoi stream",
                        },
                        isFreeForFollowers: {
                            title: "Gratuito per i follower",
                        },
                        setGoal: {
                            title: "Imposta obiettivo",
                        },
                    },
                    actions: {
                        schedule: "Pianifica",
                        save: "Salva",
                        goLive: "Vai in diretta",
                    },
                    rules: {
                        title: "Utilizzando gli spettacoli dal vivo accetti i nostri ",
                        name: "regole del flusso",
                    },
                },
                stream: {
                    title: "Streaming Privato",
                    streamIsNotLive: "Lo streaming non è ancora live",
                    messages: {
                        system: {
                            joined: "entrato",
                        },
                    },
                    liveReport: {
                        title: "Informe en Vivo",
                        totalTips: "Total de Propinas Recibidas",
                        totalTickets: "Total de Entradas Vendidas",
                        overall: "Total",
                        totalTicketsInfo: "I ricavi generati dalla vendita dei biglietti per il tuo Streaming verranno accreditati sul tuo portafoglio entro 24 ore dalla conclusione dello Streaming",
                    },
                    liveEnded: {
                        title: "En Vivo Finalizado",
                        rate: {
                            options: {
                                bad: "Scarso",
                                ok: "Ok",
                                good: "Buono",
                                loveIt: "Lo Adoro",
                            },
                        },
                    },
                    rules: {
                        title: "Utilizzando spettacoli dal vivo accetti le nostre ",
                        name: "regole di streaming",
                    },
                    streamingNow: "In streaming adesso",
                    streamStartedOn: "Iniziato {time} fa",
                },
                subscriptions: {
                    title: "Iscrizioni",
                    message_title:"(Messaggio diretto)",
                    subscription_price: "Prezzo dell'iscrizione",
                    per_month: "/Mese",
                    welcome_message: "Messaggio di benvenuto",
                    welcome_message_rule:
                        "il messaggio di benvenuto verrà inviato automaticamente ai nuovi abbonati",
                    welcome_audio_message_rule:
                        "* il messaggio audio di benvenuto verrà inviato automaticamente ai nuovi abbonati",
                    audio_note:"Tieni premuto il microfono per registrare l'audio",
                    save: "Salva",
                    subscribers: "Iscritti",
                    saved: "Fatto!",
                    text_message:"Messaggio",
                    video_message:"Audio",
                    start_date:'Data di rinnovo',
                    end_date:'Data di fine',
                    renewal_date:'Fecha de renovación',
                    total_earning:'Guadagni totali',
                    total_spent:'Totale speso',
                    default_active_label:'Attivo',
                    subscription_default_message:'Audio attivo',
                    save_price: "Salva il prezzo",
                    save_default_message: "Salva messaggio predefinito",
                    save_bundles_benefits: "Risparmia sui pacchetti e sui vantaggi",
                    gifted_subscription: "Donato da {name} ({months})",
                    gifted_by: "Donato da te ({months})",
                    terminated: "L'abbonamento è stato terminato con successo.",
                    free: "Gratuita"
                },
                tip_menu: {
                    title: "Menu dei Suggerimenti",
                    sub_title_1:
                        "Aggiungi articoli o servizi in vendita. Gli acquirenti possono acquistarli direttamente dal tuo profilo.",
                    sub_title_2:
                        "Avrai 3 giorni per consegnare la richiesta dall'acquirente.",
                    enter_name: "Aggiungi Nome dell'Articolo",
                    save: "Salva",
                    saved: "Fatto!",
                    zero_price: "Se lasci il prezzo a 0$, verrà visualizzato come 'Su richiesta'",
                    on_request: "Su richiesta",
                },
                messages: {
                    title: "Messaggi",
                    direct_messages_price: "Prezzo dei messaggi diretti",
                    placeholder: "0-49.99",
                    save: "SALVA",
                    saved: "Fatto!",
                    price_suffix: "/Mese",
                    direct_message_info: "L'utente che non vuole abbonarsi può inviarti un messaggio pagando questo prezzo"
                },
                referrals: {
                    title: "Referral",
                    description:
                        "Per chiunque si iscriva a Noodzly utilizzando il tuo codice di riferimento, riceverai un bonus pari al 3% dei loro guadagni netti per un periodo di 12 mesi. Questo bonus ti verrà pagato allo stesso tempo in cui ritirano i loro guadagni.",
                    code: "Codice",
                    links: "Legame",
                    my_referrals: "I Miei Referrals",
                    name: "Nome",
                    status: "Stato",
                    date: "Data",
                },
                promotion: {
                    title: "Promozione",
                    description:
                        'La promozione ti consente di potenziare i tuoi contenuti nella sezione "Scopri" e di raggiungere più persone che possono trasformarsi in nuovi abbonati. Prima di iniziare la tua promozione, devi avere almeno un contenuto nella tua storia.',
                    notags: "Seleziona almeno un tag",
                    countries: "Paesi",
                },

                holiday_mood: {
                    title: "Modalità vacanza",
                    description_title: "Prevedi una pausa da Noodzly?",
                    description_details: "Attiva la Modalità Vacanza per mettere in pausa gli abbonamenti dei tuoi abbonati, assicurandoti che non vengano addebitati durante la tua assenza. Questa modalità si disattiva automaticamente quando pubblichi nuovi contenuti.",
                    description_bottom: "Se rimani inattivo per 72 ore, la modalità Vacanza verrà abilitata automaticamente.",
                    active_label: "Attivare",
                },
                dream_goal: {
                    title: "Sogno",
                    description_details: "C'è qualcosa di grande che vorresti avere o raggiungere? Stabilisci un obiettivo e lascia che le persone ti aiutino con i loro contributi. Quando abilitato, il tuo Sogno è visibile sul tuo profilo a tutti.",
                    save: "Salva & Attivare",
                    stop: "Fermare",
                    placeholder: {
                        name: "Aggiungi il nome del sogno",
                        price: "Prezzo",
                    },
                    saved: "Fatto!",
                },
                moderator: {
                    title: "Moderatore",
                    description_title: "Vuoi diventare un moderatore?",
                    description_details: "Aiutaci a mantenere Noodzly sicuro e divertente per tutti. Hai notato qualcosa che viola la nostra Politica o che ti sembra pericoloso? Segnalalo.",
                    description_bottom: "Se lo rimuoviamo, guadagnerai 0,10 $ in crediti, direttamente sul tuo portafoglio. È semplicissimo: mantieni le cose pulite e sarai ricompensato.",
                    apply: "Fare domanda a",
                    requested: "Richiesto",
                    saved: "Fatto!",
                    youre_moderator: "Sei un moderatore 👮‍♀️",
                    no_reports: "Nessun rapporto trovato.",
                    total_earned : "Totale guadagnato",
                    reward: "Ricompensa",
                    rejected: "Respinto",                    
                },
                mystery_box: {
                    title: "Scatola Misteriosa",
                    price: "Prezzo",
                    total_earning: "Guadagni Totali",
                    status: "Stato",
                    heading: "Informazioni sulla Scatola Misteriosa",
                    total_available: "Totale scatole disponibili",
                    description: "Cosa c'è dentro questa scatola misteriosa? Stuzzica la curiosità dei tuoi fan..",
                    prize_table: "Tabella dei Premi",
                    add_prize: "Aggiungi Premio",
                    add_message: "Aggiungi fino a 10 articoli",
                    allow_multiple: "Consenti Aperture Multiple",
                    allow_multiple_desc: "Gli utenti possono acquistare questo più volte",
                    box_status: "Stato della Scatola",
                    box_status_desc: "Lo stato della scatola misteriosa è:",
                    save: "Scatola Misteriosa Attiva",
                    box_price: "Prezzo della Scatola",
                    remaining_boxes: "Scatole Rimanenti",
                    possible_rewards: "Premi Possibili",
                    open_box: "Apri Scatola per",
                    request_prize: "Richiedi il Tuo Premio",
                    turn_of_box: "Disattiva Scatola Misteriosa",
                    prize_sent: "Premio Inviato",
                    prize_received: "Premio Ricevuto?",
                    prize_message: "{user} ha vinto {reward}",
                    won_nothing: "Questa volta non hai vinto niente! Ti auguriamo più fortuna la prossima volta.",
                    you_won: "Hai Vinto",
                    congratulaion_message: "Congratulazioni! Hai vinto un {result} con lo streamer, {name}",
                    prize_requested: "Premio Richiesto",
                }
            },
            ideas: "Idee",
        },
        payment: {
            paypal: {
                payment_processing: "Elaborazione dei pagamenti...",
                payment_failed: "Pagamento non riuscito",
                payment_success: "Pagamento riuscito",
                payment_cancelled: "Pagamento annullato",
            },
        },
        onboard: {
            title: "Un ultimo passo!",
            gender: "Come ti identifichi?",
            interested_gender: "Mi interessa",
            age: "Quanti anni hai?",
            save: "Andiamo",
        },
    },
    profile: {
        main: {
            creator: "NOODZLER",
            info: "INFO",
            followers: "Seguaci",
            following: "Seguiti",
            get_app:"Obtener la aplicación",
            achievements: "OBIETTIVI",
            top_tippers: "I TUOI TOP DONATORI",
            no_tippers: "Nessun donatore al momento.",
            no_achievements: "Nessun obiettivo al momento.",
        },
        info: {
            title: "Informazioni",
            type_your_bio: "La tua Bio",
            amazon_url: "URL di Amazon",
            instagram_url: "URL di Instagram",
            twitter_url: "URL di X",
            my_age: "La mia età",
            i_am: "Il mio sesso",
            male: "Maschio",
            female: "Femmina",
            transgender: "Transgender",
            categories: "Categorie",
            show_achievements: "Mostra Obiettivi",
            show_achievements_desc: "Mostra agli altri il tuo badge degli obiettivi",
            show_top_tippers: "Mostra Top Donatori",
            show_top_tippers_desc: "Mostra agli altri i tuoi top donatori",
            my_countries: "Mi país",
            countries: "País",
            online_status: "Stato Online",
            online_status_desc: "Mostra agli altri quando sei online",
        },
        wallet: {
            withdraw: {
                available_balance: "Saldo disponibile",
                total_net: "Totale Netto",
                total_gross: "Totale Lordo",
                total_net_info:
                    "Il {netfee}% delle commissioni viene utilizzato per coprire l'elaborazione dei pagamenti, i pagamenti di riferimento, l'hosting, il supporto e tutti gli altri servizi per Noodzly",
                bank_transfer: "Bonifico Bancario",
                bitsafe: "Yoursafe",
                wire_transfer: "Bonifico bancario internazionale",
                crypto_wallet: "Criptovaluta",
                noodzly_fee: "Tariffa Noodzly",
                additional_fee: "Commissione bancaria",
                additinal_fee_info: "La commissione bancaria viene utilizzata per coprire l'elaborazione dei pagamenti",
                withdraw_btn: 'Ritirare',
            },
        },
        stream: {
            header: "Dirette di ",
            title: "Prossima Diretta Privata",
            purchaseTicket: "Acquista Biglietto",
            startWatching: "Inizia a Guardare",
            streamingNow: "In streaming adesso",
            streamStartedOn: "Iniziato {time} fa",
        },
        streams: {
            rating: {
                title: "Valutazione delle Dirette",
                stats: {
                    streams: "Dirette",
                    min: "min",
                    averageDuration: "Durata Media",
                },
            },
        },
    },
    search: {
        placeholder: "Cerca",
    },
    messages: {
        title: "Messaggi",
        search: "Cerca",
        turn_off_direct_messages: "Disattiva i messaggi diretti",
    },
    channels: {
        title: "Trasmissioni",
        yourChannel: "La tua trasmissione",
        description: {
            forEveryone:
                "Broadcast è un modo per ricevere messaggi dai tuoi Noodles per essere aggiornato sulla loro prossima cosa!",
            forCreators:
                "La trasmissione ti permette di inviare messaggi solo ai tuoi iscritti per tenerli aggiornati sulle tue prossime novità!",
        },
        other_user_broadcast: "Trasmissione di {user_name}",
        pinned_message: "Messaggio bloccato",
    },
    email_verify: {
        title: "Verifica Email",
        almost_there: "Quasi arrivato!",
        before_link: "Ciao {user}, abbiamo inviato una email di conferma a",
        change: "(Cambia)",
        after_link: "per iniziare, conferma la tua email.",
        button: "REINVIA EMAIL",
    },
    privacy: {
        title: "Informativa sulla privacy",
        desc_1: "Utilizzando i servizi di Noodzly.com accetti l'uso dei nostri cookie. Utilizziamo i cookie per scopi tra cui analisi, personalizzazione e annunci.",
        desc_2: "Questa pagina e alcune altre su questo sito posizionano e leggono cookie di terze parti sul tuo browser, che vengono utilizzati per scopi non essenziali. Attraverso questi cookie, i nostri partner raccolgono dati personali su di te per i loro stessi scopi.",
    },
    home: {
        desktop_description:
            "Noodzly ti permette di condividere il tuo contenuto amatoriale in totale anonimato mentre ricevi un compenso e tutto il contenuto verrà cancellato dopo 24 ore.",
        qr_code_text: "Scansiona il codice QR",
        qr_code_sub_text: "Meglio sul tuo smartphone",
        hero_content: {
            title: "Send nudes. Get paid.",
            description: "Or don't. Just be you — explore, have fun, and connect. Noodzly is your playful space to express yourself and (if you feel like it) make money. All on your own terms.",
            cta_1: "Try Noodzly Now",
            cta_2: "Login",
            stats_1: "Active Creators",
            stats_2: "Creator Earnings",
            stats_3: "Happy Users",
        },
        hero_block_img: {
            text_1: "Scan the QR code",
            text_2: "and try it from your phone.",
        },
        about_us: {
            title: "What's",
            title_highlight: "Noodzly?",
            description: "Noodzly is a real-time space where you can share amateur photos, videos, or go live. Your fans can subscribe, tip, or unlock exclusive content — totally on your terms. Just a safe, anonymous, and fun space for creators and fans to connect.",
            cta: "Let's Get Noodz 👀",
            features: {
                photo_video: {
                    alt: "photo video",
                    title: "Photo & Video",
                    subtitle: "Share your moments"
                },
                live_streams: {
                    alt: "Live Streams",
                    title: "Live Streams",
                    subtitle: "Go live anytime"
                },
                income_streams: {
                    alt: "Multiple Income Streams",
                    title: "Multiple Income Streams",
                    subtitle: "Subscriptions, tips & more"
                },
                auto_delete: {
                    alt: "24h auto delete",
                    title: "24h Auto-Delete",
                    subtitle: "Content vanishes automatically"
                },
            },
        },
        creator_benefits: {
            title_part1: "Benefits for",
            title_part2: "Creators",
            subtitle: "Snap it. Post it. Earn from it.",
            better_title: "And it gets better:",
            cta_button: "Join the Fun 🎉",
            subscriptions: {
                alt: "Subscriptions",
                title: "Subscriptions"
            },
            photo_video: {
                alt: "photo & video",
                title: "Photo & video"
            },
            pay_per_view: {
                alt: "Pay Per View Content",
                title: "Pay-per-view content"
            },
            private_streams: {
                alt: "Private Streams",
                title: "Private streams"
            },
            tips: {
                alt: "Tips",
                title: "Tips"
            },
            private_requests: {
                alt: "Private Requests",
                title: "Private requests"
            },
            referral_program: {
                alt: "Referral Program",
                title: "Referral program"
            },
            and_more: {
                alt: "And Much More Icon",
                title: "And much more!"
            },
            better_features: {
                live_solo: {
                    alt: "Subscriptions",
                    text: "Go live solo — or with another creator"
                },
                holiday_mode: {
                    alt: "photo & video",
                    text: "Pause everything anytime with \"Holiday Mode\" on your break"
                },
                privacy_controls: {
                    alt: "Pay Per View Content",
                    text: "Full privacy controls: choose who can see your profile"
                },
                disappearing_content: {
                    alt: "Private Streams",
                    text: "Share content that disappears after 24h"
                },
                fast_payouts: {
                    alt: "Tips",
                    text: "Fast and easy payouts"
                }
            },
        },
        fan_benefits: {
            title_part1: "Benefits for",
            title_part2: "Fans",
            subtitle: "Chill. Explore. Support.",
            cta_button: "Start Exploring 🔥",
            discover_content: {
                alt: "Discover Real Unfiltered Content",
                title: "Discover real, unfiltered content"
            },
            real_time: {
                alt: "Real Time People and Moments",
                title: "Real-time people and moments"
            },
            subscribe: {
                alt: "Subscribe To Your Favorite Creators",
                title: "Subscribe to your favorite creators"
            },
            tips_requests: {
                alt: "Send Tips Or Request Something Personal",
                title: "Send tips or request something personal"
            },
            easy_signup: {
                alt: "sign up With Just an Email and Password",
                title: "Sign up with just an email and password"
            },
            wallet: {
                alt: "In App Wallet To Support Your Faves",
                title: "In-app wallet to support your faves"
            }
        },
        safety: {
            title: "Safety first —",
            title_highlight: "Always",
            subtitle: "Your safety is our priority. We've built Noodzly to be a safe, trusted space.",
            trusted_space: {
                heading: "We've built Noodzly to be a safe, trusted space.",
                creators_verified: "All creators are verified",
                profile_control: "Full control over your profile visibility",
                auto_delete: "All content auto-deletes in 24h",
                secure_payments: "Payments stay inside the app with our secure wallet system",
                image_alt: "Built Noodzly To be a Safe Trusted Space"
            },
            protection: {
                heading: "Protection that matters",
                description: "We take your privacy seriously. Your data and content are fully protected and the content deleted automatically. We comply with all industry standards.",
                image_alt: "Protection That Matters"
            },
            support: {
                heading_one: "Need help?",
                heading_two: "Real humans, 24/7",
                description: "Our support team is always here to help — fast, friendly, and ready when you need us.",
                image_alt: "Need help? Real humans, 24/7"
            }
        },
        cta: {
            title: "Ready to become a Noodzler?",
            subtitle: "Whether you're here to post or just peek, there's a place for you.",
            description: "Try it now from your phone. Scan the QR code and have fun 🧡",
            qr_alt: "scan QR code"
        },
        footer_block: {
            title: "Explore, have fun, and connect",
        },
        choose_noodzly: {
            title_part1: "Perché i creatori e i fan scelgono",
            title_part2: "Noodzly",
            cta_button: "Iscriviti subito a Noodzly 🔥"
        }
    },
    user_tips: {
        title: "Menu dei Suggerimenti di {name}",
        subtitle: "Articoli o servizi in vendita da {name}",
        zero_price_text: "Vuoi richiedere {item_name}?",
        buy_item_text: "Vuoi acquistare {tip_name} per {tip_price}$?",
    },
    copyright: "&copy;{year} Noodzly. Tutti i diritti riservati.",
    other_user: {
        labels: {
            icons: {
                message: "Messaggio",
                menu: "Menu",
                tip: "Mancia",
                live: "Vivere",
                dream: "Sogno",
            },
        },
    },
    sign_up: {
        age_confirmation: "Confermo di avere almeno 18 anni",
        term_condition: "Confermo di aver letto e di accettare l'informativa",
        content_acknowledge: "Riconosco e accetto che le mie immagini e i miei contenuti possano essere utilizzati e visualizzati pubblicamente su Noodzly.",
        provider_agreement: "Confermo di aver letto e di accettare l'informativa",
    }
};
